"use client";

import { Suspense } from "react";

import Header from "./header";

export default function HeaderWrapper() {
  return (
    <Suspense>
      <Header />
    </Suspense>
  );
}
